<template>
  <!-- <div v-if="isMobile() == null">
    <router-view :key="$route.fullPath" />
  </div> -->
  <div id="app1">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  mounted() {

    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (flag == null) {
      window.location.replace("https://www.juxueyun.com");
    }

    // this.$router.replace('/')



    /*    if (this._isMobile()) {
      // alert(this._isMobile())
      // alert('手机端')
      this.$router.replace('/')
    } else {
      // alert('pc端')
      this.$router.replace('/')
    } */
  },
  methods: {
    // isMobile() {
    //   const flag = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   )
    //   return flag
    // },
  },
}
</script>

<style>
body {
  width: 750px;
}

.el-select-dropdown {
  position: fixed !important;
  left: 50% !important;
  transform: translateX(-40%);
  /* top: 322px !important; */
  /* background: red !important; */
}

.el-select-dropdown::nth-child(2) {
  position: fixed !important;
  left: 160px !important;
  /*  top: 362px !important; */
  /* background: red !important; */
}

.el-select-dropdown #app {
  /*width: 1920px;*/
  height: 100%;
}

#app2 {
  /*width: 1920px;*/
  height: 100%;
}

#app1 {
  width: 750px;
  height: 100%;
}
</style>
